export default __webpack_public_path__ + "static/CEO-Series-Blog-Image-6386fd189f78d12c8e2a1ff58a00017a.webp";